import { DWB_LESSONS_BASE_PATH } from 'containers/Product/constants'
import { getSlug } from 'utils/routing/urlHelpers'

const isTrainingCourseLink = course => {
  const source = `${course?.slug || ''} ${course?.title || ''}`.toLowerCase()
  return source.includes('training')
}

const getTier1Slug = link => {
  const source = (link?.slug || link?.title || '')
    .toString()
    .toLowerCase()
    .replace(/[–—]/g, '-')
    .trim()

  return source.replace(/\s+/g, '-')
}

const getDigitalWellBeingGradeOrTrainingSegment = course => {
  if (typeof course === 'string') return course

  if (isTrainingCourseLink(course)) return 'training'

  const fromLink = course?.slug?.trim()
  if (fromLink) return fromLink

  return (
    getTier1Slug({ title: course?.title }) ||
    getSlug(course?.title || course?.displayTitle || '')
  )
}

export const getDigitalWellBeingPreviewPath = ({ course }) => {
  const segment = getDigitalWellBeingGradeOrTrainingSegment(course)

  return `${DWB_LESSONS_BASE_PATH}/preview/${segment}`
}
